import APIClient from '@/shared/http/clients/api'

const resourceName = 'tipo-visita'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=visitName,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetAllActive = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?inative=0&sort=name,asc&size=500`, data, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (filter = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?${filter}sort=createdAt,desc&page=${index}&size=${limit}`, config)
const ChangeStatus = (id, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${id}`, config)

const VisitTypeRepository = {
  GetAll,
  GetAllPaging,
  GetAllActive,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  ChangeStatus
}

export default VisitTypeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/visittype.js